// Extracted verbatim from views/CaseDetail.js (PART C). Imports are the union
// used across the case-detail tabs; unused ones in a given tab are harmless.
import React, { useEffect, useRef, useState } from "react";
import CenteredModal from "../../components/CenteredModal";
import Spinner from "../../components/Spinner";
import Confirm from "../../components/Confirm";
import Modal from "../../components/Modal";
import { TipoPill, EstadoPill, SlaPill, TipoFalloPill, ESTADO_LABEL, PREFER_SUB_TIPO_STATES } from "../../components/Pills";
import { formatTipo } from "../../utils/case_taxonomy";
import { cases, insumos as insumosApi, users as usersApi, moderation as moderationApi } from "../../api/endpoints";
import { useAuth } from "../../auth/AuthContext";
import { useToast } from "../../components/Toast";
import InsumosTab from "../insumos/InsumosTab";
import LitisoftFields from "../../components/LitisoftFields";
import LitisoftIncompleteModal from "../../components/LitisoftIncompleteModal";
import LitisoftMandatoryInline from "../../components/LitisoftMandatoryInline";
import { TERMINO_OPTIONS, formatTermino } from "../../utils/termino";
import { canMarkContestadaDirectly, canRequestModeration, availableContestadaCategorias, CONTESTADA_LABELS as CONTESTADA_LABELS_FULL, rolesOf } from "../../utils/permissions";
import LawyerActionPanel from "../../components/lawyer/LawyerActionPanel";
import ProcesoCarpetasBanner from "../../components/ProcesoCarpetasBanner";
import CarpetaDocumentsPanel from "../../components/CarpetaDocumentsPanel";
import CarpetaStatusBadge from "../../components/CarpetaStatusBadge";
import InlineEditAccionante from "../../components/InlineEditAccionante";
import TipoFalloEditModal from "../../components/TipoFalloEditModal";
import { PERSONA_EDIT_ROLES } from "../Personas";
import { fmt, InlineEdit, hasLawyerRole, MarcarContestada, CaseFlagsToggles, hasSancionesSpecialization, SancionLifecycle, MarcarInsumoDeficiente, SolicitarModeracion, LawyerAgencyButtons, TABS, CONTESTADA_LABELS } from "./shared";

export default function AuditoriaTab({ c, user, onChanged, onClose }) {
  const toast = useToast();
  const [observations, setObservations] = useState("");
  const [busy, setBusy] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  // Same-auditor rule: reparto users (acting as auditors) — if last_auditor_id is set
  // and isn't us and we're not admin, both buttons are disabled.
  // feature/single-role-audit — multi-role aware.
  const _atRoles = rolesOf(user);
  const isAuditor = _atRoles.includes("reparto") || _atRoles.includes("admin");
  const lockedToOther = c.last_auditor_id && c.last_auditor_id !== user.id && !_atRoles.includes("admin");
  const lockedToName = c.last_auditor_name || `auditor #${c.last_auditor_id}`;

  async function doApprove() {
    if (!isAuditor) return;
    setBusy(true);
    try {
      await cases.action(c.id, "approve", { observations: observations || null });
      toast.push("Caso aprobado");
      onChanged?.();
      onClose?.();
    } catch (e) {
      toast.push(e?.response?.data?.error || "Error al aprobar", "error");
    } finally { setBusy(false); }
  }

  async function doReject() {
    if (!observations.trim()) {
      toast.push("Debe indicar observaciones para rechazar", "error");
      return;
    }
    setBusy(true);
    try {
      await cases.action(c.id, "reject", { observations });
      toast.push("Devuelto con observaciones");
      onChanged?.();
      onClose?.();
    } catch (e) {
      toast.push(e?.response?.data?.error || "Error al rechazar", "error");
    } finally { setBusy(false); }
  }

  return (
    <>
      <h3 style={{ marginTop: 0 }}>Trabajo enviado a auditoría</h3>
      <dl className="kvs">
        <dt>Abogado</dt><dd>{c.abogado_nombre || "—"}</dd>
        <dt>Observaciones del abogado</dt><dd>{c.observaciones || <span className="muted">—</span>}</dd>
        <dt>Documentos</dt><dd>{(c.documents || []).length} archivo(s)</dd>
      </dl>

      {lockedToOther && (
        <div className="warn-inline" style={{ marginTop: 12 }}>
          Esta corrección debe ser revisada por <strong>{lockedToName}</strong> (regla de mismo auditor).
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <label>Observaciones {rejecting && <span style={{ color: "var(--color-danger)" }}>*</span>}</label>
        <textarea
          value={observations}
          onChange={(e) => setObservations(e.target.value)}
          placeholder={rejecting ? "Indique las correcciones requeridas (obligatorio para rechazar)" : "Comentarios opcionales"}
        />
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
        {!rejecting ? (
          <>
            <button className="danger" disabled={busy || !isAuditor || lockedToOther} onClick={() => setRejecting(true)}>
              Devolver con observaciones
            </button>
            <button disabled={busy || !isAuditor || lockedToOther} onClick={doApprove}>
              {busy && <Spinner color="currentColor" />} Aprobar
            </button>
          </>
        ) : (
          <>
            <button className="secondary" disabled={busy} onClick={() => setRejecting(false)}>Cancelar</button>
            <button className="danger" disabled={busy} onClick={doReject}>
              {busy && <Spinner />} Confirmar rechazo
            </button>
          </>
        )}
      </div>
    </>
  );
}
